import Validator from "../../../utils/Validator";

const DEFAULT_TRUE = 'X';
const DEFAULT_FALSE = '-';
const DEFAULT_NULL = ' ';
const NULL_VALUE = 'null';
const SPACE_PLC = '$SPACE';

/**
 * Logic mapping helper class
 */
export default class LogicMapping {

    /**
     * constructs a new instance
     * @param {string} spec mapping specification
     */
    constructor(spec) {
        const mappings = spec.split(',');
        if ( mappings.length >= 2 ) {
            this._strTrue = Validator.effectiveString(mappings[0].trim(), DEFAULT_TRUE);
            this._strFalse = Validator.effectiveString(mappings[1].trim(), DEFAULT_FALSE);
            this._strNull = LogicMapping._getNullMapping(Validator.effectiveString(mappings[2].trim(), DEFAULT_NULL));
        } else {
            this._strTrue = DEFAULT_TRUE;
            this._strFalse = DEFAULT_FALSE;
            this._strNull = DEFAULT_NULL;
        }
        Object.freeze(this);
    }

    /**
     * retrieves the effective mapping for null values
     * @param {String} mapping the mapping as provided by the backend
     * @returns {String} the effecitve mapping for null values
     */
    static _getNullMapping(mapping) {
        if ( !Validator.isString(mapping) || SPACE_PLC === mapping ) {
            return DEFAULT_NULL;
        }
        return mapping;
    }

    /**
     * maps a value that represents a logic value to the mathcing string
     * @param {*} value the logic value
     * @returns {String} the matching string
     */
    mapValue(value) {
        if ( typeof value === 'boolean' ) {
            return value ? this._strTrue : this._strFalse;
        }
        if ( !Validator.isString(value) || (NULL_VALUE === value) ) {
            return this._strNull;
        }
        return Validator.isTrue(value) ? this._strTrue : this._strFalse;
    }

}

